import client from "@/utils/api/client";
import { UserAttributesResponse } from "@/web-client/api";
import { useMemo } from "react";
import useSWR from "swr";

const useUserAttributes = (): UserAttributesResponse => {
  const { data } = useSWR<UserAttributesResponse>(
    "/industries",
    async () => {
      const { data } = await client.userAttributesGet();

      return data;
    },
    { revalidateOnFocus: false, revalidateOnReconnect: false },
  );

  const industries = useMemo(() => {
    if (!data) return [];

    return data.industries;
  }, [data]);

  const occupations = useMemo(() => {
    if (!data) return [];

    return data.occupations;
  }, [data]);

  return { occupations, industries };
};

export default useUserAttributes;
